import { useEffect } from "react";

export const useNoIndex = () => {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]');
    const created = !meta;
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    const previousContent = meta.getAttribute("content");
    meta.setAttribute("content", "noindex, nofollow");

    return () => {
      if (created) {
        meta.remove();
      } else {
        meta.setAttribute("content", previousContent || "index, follow");
      }
    };
  }, []);
};
